function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import styles from "./SimpleButton.module.sass";
const SimpleButton = ({
  children,
  className,
  submit,
  primary,
  critical,
  ...attributes
}) => /*#__PURE__*/React.createElement("button", _extends({
  className: `${styles["button"]} ${submit || primary ? styles["submit"] : ""} ${critical ? styles["critical"] : ""} ${className || ""}`
}, attributes), children);
export default SimpleButton;